define('viewModels/privileged/qm/policies/editors/AgentSelectorView',[
    'lib/lodash4',
    'lib/bluebird',
    'lib/knockout',
    'services/userService',
    'services/loggingService',
    'viewModels/ViewModel',

    // No references
    'extensions/i18n/knockout.i18n',
    'lib/knockout.validation'
], function (_, Promise, ko, userService, LOG, ViewModel) {
    'use strict';

    /**
     * The AgentSelectorView class.
     * @class
     */
    var AgentSelectorView = ViewModel.extend(function (agentsObservable, options) {
        var self = this;

        self.agents = agentsObservable;
        self.placeholderText = ko.i18n.renderString('agentSelectorView.placeholderText');
        self.qualityEvaluatorPlaceholderText = ko.i18n.renderString('agentSelectorView.qualityEvaluator.placeholderText');
        self.qualityAdminPlaceholderText = ko.i18n.renderString('agentSelectorView.qualityAdmin.placeholderText');
        self.isOpen = ko.observable(false);

        var lookupUsers = function (searchTerm) {
            var query = [];

            if (options && options.userStates) {
                query.push({
                    fields: ['state'],
                    values: options.userStates,
                    type: 'EXACT',
                    operator: 'OR'
                });
            }

            if (searchTerm.length > 0) {
                query.push({
                    fields: ['name'],
                    value: searchTerm,
                    type: 'CONTAINS',
                    operator: 'AND'
                });
            }

            var queryObject = {
                pageSize: 25,
                types: ['users'],
                query: query
            };

            return userService.searchUsers(queryObject)
                .then(function (response) {
                    var filteredAgents = ko.toJS(response);
                    var unwrappedAgents = ko.unwrap(self.agents);

                    // Remove the already-selected agents from the list
                    _.remove(filteredAgents, function (agent) {
                        return _.find(unwrappedAgents, {"id": agent.id});
                    });

                    //Removes ignored users if specified.
                    if (options && options.ignoredIds) {
                        _.remove(filteredAgents, function(agent) {
                            return _.includes(options.ignoredIds(), agent.id);
                        });
                    }

                    return filteredAgents;
                })
                .catch(function (error) {
                    LOG.error("Couldn't retrieve users", { error: error });
                    return [];
                });
        };

        self.getQualityEvaluators = function(searchTerm) {
            LOG.info("AgentSelectorView.getQualityEvaluators is deprecated due to roles being more fluid.");
            return lookupUsers(searchTerm, 'qualityEvaluator');
        };

        self.getQualityAdmins = function(searchTerm) {
            LOG.info("AgentSelectorView.getQualityAdmins is deprecated due to roles being more fluid.");
            return lookupUsers(searchTerm, 'qualityAdmin');
        };

        self.getAgents = function (searchTerm) {
            return lookupUsers(searchTerm);
        };

        if (_.isArray(self.agents())) {
            self.agents.extend({deepComparer: true, minLength: {params: 1, message: "agentSelectorView.noAgentsSelected"}});
        } else {
            self.agents.extend({required: true});
        }

    }, true /* pass args to extended class */);

    return AgentSelectorView;
});

